// sphereInfoAPI.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const GRAPH_SERVICE_URL = process.env.REACT_APP_GRAPH_ENDPOINT || 'https://your-graph-service';

export const sphereInfoAPI = createApi({
  reducerPath: 'sphereInfoAPI',
  baseQuery: fetchBaseQuery({ baseUrl: GRAPH_SERVICE_URL }),
  endpoints: (builder) => ({
    // Accept an object with { sphereId, token }
    getSphereInfo: builder.query<any, { sphereId: string; token: string }>({
      query: ({ sphereId, token }) => ({
        url: `spheres/${sphereId}/info`,
        // Add the Authorization header
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      // Keep data in cache for 15 minutes (900 seconds)
      keepUnusedDataFor: 900,
    }),
  }),
});

export const { useGetSphereInfoQuery } = sphereInfoAPI;
